import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import API_Config from '../API_Config';
import Pagination from "react-js-pagination";

import MetaTags from 'react-meta-tags';
import ReactHtmlParser from 'react-html-parser';
import $ from "jquery";
class PressRelease extends Component {

    constructor(props) {
        super(props);
        this.state = {
            activePage: 1,
            page_count:0,
            data:[ {
                title: '',
                content: '',
                img_path: '',
                slug : '',
                time_stamp : ''
            }],
            slug   : props.match.params.slug,
        };
        this.handlePageChange = this.handlePageChange.bind(this);

            localStorage.setItem('catData',"");

    }

    componentDidMount() {
        this.GetContentData(0);
    }
    GetContentData(params) {
        let url = API_Config.http_url+'/press-release/getPress?start='+params+'';
        fetch(url)
            .then(res => res.json())
            .then(
                (result) => {
                    this.setState({
                        data: result.data,
                        page_count:result.total
                    });
                },
                (error) => {

                }
            )

    }
    handlePageChange(pageNumber) {

        this.setState({activePage: pageNumber});
        this.GetContentData(pageNumber);

    }

    showModalView(data) {
        console.log('data',data)

        data.title = "";
        localStorage.setItem("reportdata",JSON.stringify(data))
        localStorage.setItem("pressRelease","Press Release");

        $("#model_report_id").val("");
        $("#model_report_name").val(data.title);



    }

    render() {

        return (
<div>
<section class="ovrfl">
    <MetaTags>
        <title>Mordor Intelligence -  Press Release</title>
        <meta id="description" name="description" content="Mordor Intelligence -  Press Release" />
        <meta id="keywords" name="keywords" content="Mordor,Market,Press,Press-Release,Release" />
    </MetaTags>
    <div class="container flash_con_pad">
        <div class="row breadcrumb text-center trght">
            <div class="col-md-12"> <Link to="/"><span>Home</span></Link> <i class="fa fa-angle-right"></i> <span>Press Release </span> </div>
        </div>
        <div class="row">
            <div class="col-md-8">
                <div class="row">


                    {this.state.data.map(i => {
                        let content = ReactHtmlParser(i.content.substring(0,350));

                        return(
                            <div class="report_card press_card" onClick={() => this.showModalView(i)}>
                                <article class="report_bg">
                                    <div class="clearfix">
                                        <section class="press_img">
                                            <img src={ 'https://mordorintelligence.com:81/images_db/' + i.img_path } data-src={ 'https://mordorintelligence.com:81/admin-345336admin/images_db/' + i.img_path } alt={i.slug}></img>
                                        </section>
                                        <section class="press_txt">
                                            <span>February 2018</span><br></br>
                                            <Link to= {'/press-article/' + i.slug} ><h3>{i.title}</h3></Link>
                                            <p>{content}</p>
                                            <Link to= {'/press-article/' + i.slug} >Read More</Link>
                                        </section>
                                    </div>
                                </article>
                            </div>
                        )
                    })}

                </div>
                <div class="row text-center">
                <Pagination
                    activePage={this.state.activePage}
                    itemsCountPerPage={10}
                    totalItemsCount={this.state.page_count}
                    pageRangeDisplayed={5}
                    onChange={this.handlePageChange}
                />
                </div>
            </div>
            {/*<div class="col-md-4 preerelese_side">*/}
                {/*<div>*/}
                    {/*<div class="report_adds press_adds">*/}
                        {/*<div class="report_addc">*/}
                            {/*<h3>Download a Full Report</h3>*/}
                            {/*<div class="tag_line">A taste of our expansive industry coverage in over 60 sectors</div>*/}
                            {/*<a href="#"><button class="dwn_btn1 open-AddBookDialog" data-toggle="modal" data-backdrop="static" data-target="#myModalnew" data-id="^^^^^^^"><i class="fa fa-download"></i> Download Free Report <span>345 kb</span></button></a>*/}

                        {/*</div>*/}
                    {/*</div>*/}
                {/*</div>*/}

            {/*</div>*/}
        </div>


    </div>
</section>
</div>

    );

    }


    }
    export default PressRelease;


// WEBPACK FOOTER //
// ./src/press-release/PressRelease.js